export enum PropertyTabsKeys {
  INFORMATION = 'INFORMATION',
  ADVANCED = 'ADVANCED',
  INVENTORY = 'INVENTORY',
  FEATURES_AND_AMENITIES = 'FEATURES_AND_AMENITIES',
  MEDIA = 'MEDIA',
  NOTES = 'NOTES',
  CHANGELOGS = 'CHANGELOGS',
}

export const DEFAULT_PROPERTY_TAB_KEY = PropertyTabsKeys.INFORMATION;
